const API_BASE_URL = 'https://khvuxdskc6.execute-api.us-east-2.amazonaws.com/prod';

export default API_BASE_URL;
